// removed by extract-text-webpack-plugin
module.exports = {"buttonOutline":"kYt2w8GuthbZbgvzewTre","buttonRemove":"kZ-MzmXVDGLtvD8Qq3kdA","titleRow":"_1YXkPlpWAEbdWrj-XYiWpV","title":"_1VuIduAcTyrt-iVmi2htHk","required":"_3V18Dz9IG3-M7fQ-r-Uf2D","value":"G1RsvB4F-OUm2BK8cyOKR"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/TaskNew/style.scss
// module id = 1060
// module chunks = 0